import { ADD_RECENT_EMOJI } from './types';

export const addRecentEmoji = (emoji) => (dispatch, getState) => {
  dispatch({
    type: ADD_RECENT_EMOJI,
    emoji: emoji,
  })
}
